import BaseComponent from '../../../js/base-component';
import { Modal } from '../../../js/modal';

class CareProductsStepSeven extends BaseComponent {
    constructor(element) {
        super(element);

        let legalAttendant = this.element.querySelectorAll('input[name="legalAttendant"]') || '';
        let checked = this.element.querySelector('input[name="legalAttendant"]:checked') || {};
        let applicant = this.element.querySelector('.u-care-products__content-right');
        let formfields = document.querySelector('#formfields') || '';
        const requiredFields = formfields.querySelectorAll(':required') || '';

        this.editButton = this.element.querySelectorAll('.u-edit--person');
        this.editModalContainer = document.querySelector('#editModal') || '';
        this.editModal = new Modal( this.editModalContainer );

        this.editButton.forEach( element => {
            element.addEventListener('click', (evt) => {
                this.editModal.handleModal('person','open', {id: element.dataset.id, contract: element.dataset.contract, headline: element.dataset.headline });
            });
        });

        legalAttendant.forEach((ele) => {
            ele.addEventListener("click", (e) => { this.checkRadio( e.target.value,  formfields, requiredFields ) });
        });

        if (applicant.dataset.applicant == 'representative') {
            checked.value = '1';
        }

        if (checked !== null) {
            // this.checkBirthday();
            this.checkRadio( checked.value, formfields, requiredFields );
        }
    }

    onInit() {}

    checkRadio = (state, ele, required)  => {
        if ( state === '0' ) {
           ele.classList.add('hidden');
        }

        if ( state === '1' ) {
            ele.classList.remove('hidden');
        }

         // add/remove required attribte of formfields
         this.setRequiredFields(state, required);
    }

    setRequiredFields = (state, required) => {
        // remove required attribute of formfields
        if ( state === '0' ) {
             required.forEach(ele => {
                 ele.removeAttribute("required");
             });
         }

         // add required attribute if not present
        if ( state === '1' ) {
            required.forEach(ele => {
                if (!ele.hasAttribute("required")) {
                    ele.setAttribute("required","");
                }
            });
        }
    }
}

export default {
    name: 'CareProductsStepSeven',
    definition: CareProductsStepSeven
};